<template>
  <div class="pa-2 text-center">
    <h3 class="ma-4 mt-12"> Verify Your Terminal Teller Account </h3>
    <amplify-authenticator v-if="!signedIn" :authConfig="configurationOptions">
      <div>
        Verify
        <amplify-sign-out></amplify-sign-out>
      </div>
    </amplify-authenticator>
    <v-alert type="success" v-if="signedIn">
      User successfully enrolled for Terminals at Venue {{venue}} you can now close this window.<br>
      <v-btn @click="signOut()">Return to Login Screen</v-btn>
      <br>
      OR
      <br>
      **For Admins - please continue to this <a :href="linkAdmin">link</a>**

    </v-alert>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  data: () => ({
    configurationOptions: {
      signInConfig: {
        isSignUpDisplayed: false
      }
    },
    venue: ''
  }),
  watch: {
    signedIn() {
      if (this.signedIn) {
        this.getVenue()
      }
      if (this.authstate === 'NEW_PASSWORD_REQUIRED') {
        Auth.signOut()
        this.$router.push({ path: `/verify/?username=${this.authenticatedUser}`,})
      }
    },
  },
  methods: {
    validate () {
      this.$refs.form.validate()
    },
    async signOut () {
      await Auth?.signOut()
      this.$router.go(-2)
    },
    async getVenue () {
      const data = await Auth.currentAuthenticatedUser()
      const group = data.signInUserSession.accessToken.payload['cognito:groups'] || ''
      const mainGroup = group[0] || ''
      this.venue = mainGroup
    }
  },
  props: {
    signedIn: Boolean
  },
  computed: {
    authenticatedUser () {
      return this.$route.query.username
    },
    authstate () {
      return this.$route.query.authstate
    },
    linkAdmin () {
      const link = `${process.env.VUE_APP_WRAPPER_URL}/admin`
      return link
    }
  }
}
</script>

<style>

</style>